export default __webpack_public_path__ + "static/media/about-grid-03.bce361f6.jpg";